export const SET_LOADING = 'SET_LOADING'

export const CREATE_ORDER = 'CREATE_ORDER'
export const EDIT_ORDER = 'EDIT_ORDER'
export const EDIT_RESERVATION = 'EDIT_RESERVATION'
export const CREATE_SUPPLIER_ORDER = 'CREATE_SUPPLIER_ORDER'

export const FETCH_ORDER_PRODUCTS = 'FETCH_ORDER_PRODUCTS'
export const FETCH_ORDER = 'FETCH_ORDER'

export const FETCH_RESERVATION_PRODUCTS = 'FETCH_RESERVATION_PRODUCTS'
export const FETCH_RESERVATION = 'FETCH_RESERVATION'

export const FETCH_ORDER_PRODUCT_LIST = 'FETCH_ORDER_PRODUCT_LIST'
export const REPAY_ORDER = 'REPAY_ORDER'
export const EDIT_SELECTED_COURIER = 'EDIT_SELECTED_COURIER'

export const FETCH_ORDERS = 'FETCH_ORDERS'
export const FETCH_ORDERS_META = 'FETCH_ORDERS_META'

export const FETCH_RESERVATIONS = 'FETCH_RESERVATIONS'
export const FETCH_RESERVATIONS_META = 'FETCH_RESERVATIONS_META'

export const FETCH_ORDERS_PRODUCTS = 'FETCH_ORDERS_PRODUCTS'
export const FETCH_ORDERS_PRODUCTS_META = 'FETCH_ORDERS_PRODUCTS_META'

export const FETCH_CARTS = 'FETCH_CARTS'
export const FETCH_CARTS_META = 'FETCH_CARTS_META'

export const FETCH_SUPPLIER_ORDER_PRESIGNED_URL = 'FETCH_SUPPLIER_ORDER_PRESIGNED_URL'
export const FETCH_SUPPLIER_ORDERS = 'FETCH_SUPPLIER_ORDERS'
export const FETCH_SUPPLIER_ORDERS_META = 'FETCH_SUPPLIER_ORDERS_META'

export const FETCH_SUPPLIER_ORDER_PRODUCTS = 'FETCH_SUPPLIER_ORDER_PRODUCTS'
export const FETCH_ORDER_SEARCH_SUGGESTIONS = 'FETCH_ORDER_SEARCH_SUGGESTIONS'

export const FETCH_RETURNING_ORDER = 'FETCH_RETURNING_ORDER'
export const FETCH_RETURNING_ORDERS = 'FETCH_RETURNING_ORDERS'
export const FETCH_RETURNING_ORDERS_META = 'FETCH_RETURNING_ORDERS_META'
export const FETCH_RETURNING_ORDERS_PRODUCTS = 'FETCH_RETURNING_ORDERS_PRODUCTS'
export const FETCH_RETURNING_ORDERS_PRODUCTS_META = 'FETCH_RETURNING_ORDERS_PRODUCTS_META'
export const FETCH_RETURNING_ORDER_PRODUCT_LIST = 'FETCH_RETURNING_ORDER_PRODUCT_LIST'
export const FETCH_RETURNING_ORDER_PRODUCTS = 'FETCH_RETURNING_ORDER_PRODUCTS'
export const CREATE_RETURNING_ORDER = 'CREATE_RETURNING_ORDER'
export const EDIT_ORDER_PRODUCT = 'EDIT_ORDER_PRODUCT'
export const UPDATE_RETURNING_ORDER = 'UPDATE_RETURNING_ORDER'
export const REMOVE_ORDER_PRODUCT = 'REMOVE_ORDER_PRODUCT'

